import Skill from '@/api/skill';
import EntityView from '@/views/EntityView.vue';

export const SKILL_ROUTE = [
  {
    path: `/${Skill.SLUG}/`,
    name: `${Skill.SLUG}-list`,
    component: EntityView,
    props: () => ({
      entity: Skill.SLUG
    }),

    meta: {
      title: 'Skills · ELSA Content Creator'
    }
  },
  {
    path: `/${Skill.SLUG}/new`,
    name: `${Skill.SLUG}-new`,
    component: EntityView,
    props: () => ({
      entity: Skill.SLUG,
      isNew: true,
      isEdit: true
    }),

    meta: {
      title: 'New Skill · ELSA Content Creator'
    }
  },
  {
    path: `/${Skill.SLUG}/:id(\\d+)`,
    name: `${Skill.SLUG}-edit`,
    component: EntityView,
    props: (route) => ({
      entity: Skill.SLUG,
      id: parseInt(route.params.id, 10),
      isEdit: true
    }),
    meta: {
      title: 'Edit Skill · ELSA Content Creator'
    }
  }
];
